export default "__VITE_ASSET__C7AmnAY8__"